"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Search = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _uxcore = require("@ux/uxcore2");

var _constants = require("../constants");

var _actions = require("../store/actions");

var _app = require("../store/reducers/app");

var _searchResults = require("../store/reducers/searchResults");

var _searchSuggestions = require("../store/reducers/searchSuggestions");

var _styles = _interopRequireDefault(require("../styles"));

var _Style = _interopRequireDefault(require("./Style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Search =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Search, _PureComponent);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props));
    _this.historyEntryEqual = _this.historyEntryEqual.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleClickSubmit = _this.handleClickSubmit.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleSuggestionItemHover = _this.handleSuggestionItemHover.bind(_assertThisInitialized(_this));
    _this.setSearchRef = _this.setSearchRef.bind(_assertThisInitialized(_this));
    _this.handleClickOutsideSearch = _this.handleClickOutsideSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutsideSearch);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var searchSuggestions = this.props.searchSuggestions;

      if (searchSuggestions.length > 0 && JSON.stringify(searchSuggestions) !== JSON.stringify(prevProps.searchSuggestions)) {
        this.handleSearchSuggestionsViewed();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutsideSearch);
    }
  }, {
    key: "setSearchRef",
    value: function setSearchRef(node) {
      this.searchRef = node;
    }
  }, {
    key: "handleClickOutsideSearch",
    value: function handleClickOutsideSearch(event) {
      if (this.searchRef && !this.searchRef.contains(event.target)) {
        this.props.searchSuggestionsClear();
      }
    }
  }, {
    key: "historyEntryEqual",
    value: function historyEntryEqual(pathnameNew) {
      var pathname = this.props.location.pathname;
      return pathname === pathnameNew;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.props.appQuerySet(event.target.value);
      this.props.searchSuggestionsSetIndex(-1);

      if (event.target.value.length) {
        this.props.searchSuggestionsGet(event.target.value);
      } else {
        this.props.searchSuggestionsClear();
      }
    }
  }, {
    key: "handleClickSubmit",
    value: function handleClickSubmit() {
      var appQuery = this.props.appQuery;
      this.submit();
      this.props.searchSuggestionsSetIndex(-1);
      this.props.trafficSearchSubmit({
        query: appQuery,
        type: 'click'
      });
    }
  }, {
    key: "handleClickSearchSuggestion",
    value: function () {
      var _handleClickSearchSuggestion = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(text) {
        var _this$props, appQuery, searchResults, nextHistoryEntry;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, appQuery = _this$props.appQuery, searchResults = _this$props.searchResults;
                if (!searchResults[text]) this.props.searchResultsGet({
                  query: text
                });
                this.props.appQuerySet(text);
                this.props.searchSuggestionsClear();
                nextHistoryEntry = "/search/".concat(text, "/1");

                if (!this.historyEntryEqual(nextHistoryEntry)) {
                  this.props.history.push(nextHistoryEntry);
                }

                this.props.trafficSearchSuggestionClick({
                  query: appQuery,
                  suggestion: text
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleClickSearchSuggestion(_x) {
        return _handleClickSearchSuggestion.apply(this, arguments);
      }

      return handleClickSearchSuggestion;
    }()
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var _this$props2 = this.props,
          activeSuggestion = _this$props2.activeSuggestion,
          appQuery = _this$props2.appQuery,
          searchSuggestions = _this$props2.searchSuggestions;

      if (event.key === 'Enter') {
        if (searchSuggestions[activeSuggestion]) {
          this.props.trafficSearchSuggestionClick({
            query: appQuery,
            suggestion: searchSuggestions[activeSuggestion].text
          });
          this.submit();
        } else {
          this.submit();
          this.props.trafficSearchSubmit({
            query: appQuery,
            type: 'enter'
          });
        }
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.props.searchSuggestionsSetIndex(Math.min(activeSuggestion + 1, searchSuggestions.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.props.searchSuggestionsSetIndex(Math.max(activeSuggestion - 1, 0));
      }
    }
  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this$props3, activeSuggestion, appQuery, searchResults, searchSuggestions, query, nextHistoryEntry;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props3 = this.props, activeSuggestion = _this$props3.activeSuggestion, appQuery = _this$props3.appQuery, searchResults = _this$props3.searchResults, searchSuggestions = _this$props3.searchSuggestions;

                if (appQuery.length) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                this.props.searchSuggestionsClear(); // If the user is hovering/selecting a search suggestion, activeSuggestion will
                // be nonnegative and we should use the suggestion rather than the content in the
                // input box.

                query = activeSuggestion < 0 ? appQuery : searchSuggestions[activeSuggestion].text;
                nextHistoryEntry = "/search/".concat(query, "/1");

                if (!this.historyEntryEqual(nextHistoryEntry)) {
                  this.props.history.push(nextHistoryEntry);
                }

                this.props.appQuerySet(query);

                if (searchResults[query]) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return this.props.searchResultsGet({
                  query: query
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function submit() {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "handleSuggestionItemHover",
    value: function handleSuggestionItemHover(index) {
      this.props.searchSuggestionsSetIndex(index);
    }
  }, {
    key: "handleSearchSuggestionsViewed",
    value: function handleSearchSuggestionsViewed() {
      var _this$props4 = this.props,
          appQuery = _this$props4.appQuery,
          searchSuggestions = _this$props4.searchSuggestions;

      if (searchSuggestions) {
        this.props.trafficSearchSuggestionsView({
          count: searchSuggestions.length,
          query: appQuery,
          suggestions: searchSuggestions.map(function (suggestion) {
            return suggestion.text;
          })
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          activeSuggestion = _this$props5.activeSuggestion,
          appQuery = _this$props5.appQuery,
          searchSuggestions = _this$props5.searchSuggestions,
          market = _this$props5.market;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        ref: this.setSearchRef,
        className: "help--search-container"
      }, _react.default.createElement("div", {
        className: "help--search-input-container"
      }, _react.default.createElement("input", {
        className: "help--search-input",
        value: appQuery,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        placeholder: market === _constants.MARKET_EN_US && 'Search Help' || '',
        type: "text"
      }), _react.default.createElement("div", {
        className: "help--search-submit",
        onClick: this.handleClickSubmit,
        onKeyDown: null,
        role: "button",
        tabIndex: 0
      }, _react.default.createElement(_uxcore.Icon, {
        name: "magnifying-glass",
        size: 18,
        color: _styles.default.colors.black
      }))), _react.default.createElement("div", {
        className: "help--search-suggestions"
      }, searchSuggestions && searchSuggestions.map(function (searchSuggestion, index) {
        return _react.default.createElement("div", {
          className: "help--search-suggestions-item ".concat(activeSuggestion === index ? 'help--search-suggestions-item-active' : ''),
          onClick: function onClick() {
            return _this2.handleClickSearchSuggestion(searchSuggestion.text);
          },
          onMouseEnter: function onMouseEnter() {
            return _this2.handleSuggestionItemHover(index);
          },
          onFocus: function onFocus() {
            return _this2.handleSuggestionItemHover(index);
          },
          onKeyDown: null,
          key: index,
          role: "button",
          tabIndex: 0
        }, _react.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: searchSuggestion.text.replace(appQuery, "<b>".concat(appQuery, "</b>"))
          }
        }));
      }))), _react.default.createElement(_Style.default, {
        css: "\n          .help--search-container {\n            position: relative;\n          }\n\n          .help--search-input-container {\n            align-items: center;\n            background-color: ".concat(_styles.default.colors.grayFaint, ";\n            border-bottom: 1px solid ").concat(_styles.default.colors.grayLight, ";\n            display: flex;\n            flex: 1;\n            height: ").concat(_styles.default.sizes.search, "px;\n            justify-content: center;\n            padding: 0.5em 1.5em;\n          }\n\n          .help--search-input {\n            background-color: ").concat(_styles.default.colors.grayFaint, ";\n            border: none;\n            height: 100%;\n            outline: none;\n            width: 100%;\n          }\n\n          .help--search-submit {\n            align-items: center;\n            background-color: ").concat(_styles.default.colors.grayFaint, ";\n            cursor: pointer;\n            display: flex;\n            height: 100%;\n            justify-content: center;\n            outline: none;\n            width: 40px;\n          }\n\n          .help--search-suggestions {\n            background-color: ").concat(_styles.default.colors.white, ";\n            box-shadow: 0 2px 4px rgba(182, 182, 182, 0.75);\n            position: absolute;\n            top: ").concat(_styles.default.sizes.search, "px;\n            width: 100%;\n            z-index: 1;\n          }\n\n          .help--search-suggestions-item {\n            cursor: pointer;\n            outline: none;\n            padding: 0.75em;\n          }\n\n          .help--search-suggestions-item-active {\n            background-color: ").concat(_styles.default.colors.grayFaint, ";\n            color: ").concat(_styles.default.colors.blue, ";\n          }\n        ")
      }));
    }
  }]);

  return Search;
}(_react.PureComponent);

exports.Search = Search;
Search.propTypes = {
  activeSuggestion: _propTypes.default.number.isRequired,
  appQuery: _app.appPropTypes.query,
  appQuerySet: _propTypes.default.func.isRequired,
  appTopicId: _app.appPropTypes.topicId,
  history: _propTypes.default.object.isRequired,
  location: _propTypes.default.object.isRequired,
  market: _app.appPropTypes.market,
  searchResults: _searchResults.searchResultsPropType,
  searchResultsGet: _propTypes.default.func.isRequired,
  searchSuggestions: _searchSuggestions.searchSuggestionsPropType,
  searchSuggestionsClear: _propTypes.default.func.isRequired,
  searchSuggestionsGet: _propTypes.default.func.isRequired,
  searchSuggestionsSetIndex: _propTypes.default.func.isRequired,
  trafficSearchSubmit: _propTypes.default.func.isRequired,
  trafficSearchSuggestionClick: _propTypes.default.func.isRequired,
  trafficSearchSuggestionsView: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeSuggestion: state.searchSuggestions.activeSuggestion,
    appQuery: state.app.query,
    appTopicId: state.app.topicId,
    market: state.app.market,
    searchResults: state.searchResults,
    searchSuggestions: state.searchSuggestions.suggestions
  };
};

var mapDispatchToProps = {
  appQuerySet: _actions.appQuerySet,
  searchResultsGet: _actions.searchResultsGet,
  searchSuggestionsClear: _actions.searchSuggestionsClear,
  searchSuggestionsGet: _actions.searchSuggestionsGet,
  searchSuggestionsSetIndex: _actions.searchSuggestionsSetIndex,
  trafficSearchSubmit: _actions.trafficSearchSubmit,
  trafficSearchSuggestionClick: _actions.trafficSearchSuggestionClick,
  trafficSearchSuggestionsView: _actions.trafficSearchSuggestionsView
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search));

exports.default = _default;